module.exports = __webpack_public_path__ + "static/media/countdown.b253991.ogg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/countdown.ogg
// module id = 5bUS
// module chunks = 1